export const isDarkMode = (color?: string) =>
	color === "var(--color-neutral-black-80)" || color?.includes("--color-neutral-black-80");

type BlokWithBackground = Record<string, unknown>;

export const checkBlokBackground = (obj: BlokWithBackground): string | undefined => {
	if (
		typeof obj.bg === "object" &&
		obj.bg !== null &&
		"value" in obj.bg &&
		typeof obj.bg.value === "string"
	) {
		return obj.bg.value;
	}
	return undefined;
};
